/* Range Comparison — assets/range-comparison.js (jQuery)
   Loads jQuery automatically if the theme doesn't already include it. */
(function () {
  function init($) {
    var SVGNS = 'http://www.w3.org/2000/svg';

    function el(tag, attrs) {
      var n = document.createElementNS(SVGNS, tag);
      for (var k in attrs) n.setAttribute(k, attrs[k]);
      return n;
    }

    function toHours(r) { return (parseFloat(r.h) || 0) + (parseFloat(r.m) || 0) / 60; }
    function hasValue(r) { return r && (r.h !== '' || r.m !== ''); }

    function setup($root) {
      if ($root.data('rcInit')) return;
      $root.data('rcInit', true);

      var data;
      try { data = JSON.parse($root.find('[data-rc-json]').text()); } catch (e) { return; }
      if (!data.tabs || !data.tabs.length) return;

      var labels = data.labels;          // ["Pro","Amateur","Beginner"]
      var baseline = data.highlight;     // 0-based row that gets the "Baseline" tag
      var tag = data.tag;                // "Baseline"
      var naText = data.naText || 'N/A'; // shown for empty rows
      var greenMode = data.greenMode || 'longest'; // 'longest' | 'baseline'

      // Which row is green in a tab: the longest time (default) or always the baseline row
      function greenIndex(t) {
        if (greenMode === 'baseline') return baseline;
        var best = -1, bestV = -1;
        t.rows.forEach(function (r, ri) {
          if (hasValue(r) && toHours(r) > bestV) { bestV = toHours(r); best = ri; }
        });
        return best;
      }
      var $tabs = $root.find('.rc__tab');
      var $stats = $root.find('[data-rc-stats]');
      var $chart = $root.find('[data-rc-chart]');
      var active = 0;

      // ---------- Chart ----------
      var W = 544, H = 320, X0 = 64, X1 = 480, Y0 = 288, Y1 = 48;
      var maxAll = 0;
      data.tabs.forEach(function (t) {
        t.rows.forEach(function (r) { if (hasValue(r)) maxAll = Math.max(maxAll, toHours(r)); });
      });
      var yMax = data.chartMax > 0 ? data.chartMax : Math.ceil(maxAll * 2) / 2 || 1;
      var steps = 7;

      function y(v) { return Y0 - (Math.min(v, yMax) / yMax) * (Y0 - Y1); }

      function barPath(x, top, w) {
        var r = Math.min(3, w / 2), h = Y0 - top;
        if (h < r) r = Math.max(h, 0);
        return 'M' + x + ' ' + Y0 + 'L' + x + ' ' + (top + r) +
          'Q' + x + ' ' + top + ' ' + (x + r) + ' ' + top +
          'L' + (x + w - r) + ' ' + top +
          'Q' + (x + w) + ' ' + top + ' ' + (x + w) + ' ' + (top + r) +
          'L' + (x + w) + ' ' + Y0 + 'Z';
      }

      var svg = el('svg', { viewBox: '0 0 ' + W + ' ' + H, 'class': 'rc__svg', role: 'img', 'aria-label': data.chartLabel || 'Range chart' });

      // grid + axis labels
      for (var i = 0; i <= steps; i++) {
        var val = yMax * (steps - i) / steps;
        var gy = Y1 + (Y0 - Y1) * i / steps;
        svg.appendChild(el('line', { x1: X0, y1: gy, x2: X1, y2: gy, 'class': 'rc__grid-line' + (i === steps ? ' rc__grid-line--main' : '') }));
        var tl = el('text', { x: 48, y: gy + 4, 'text-anchor': 'end', 'class': 'rc__axis' }); tl.textContent = val.toFixed(1);
        var tr = el('text', { x: 496, y: gy + 4, 'text-anchor': 'start', 'class': 'rc__axis' }); tr.textContent = val.toFixed(1);
        svg.appendChild(tl); svg.appendChild(tr);
      }

      // groups (one per tab)
      var n = data.tabs.length;
      var span = (X1 - X0) / n;
      var gw = Math.min(80, span - 8);
      var groups = [];
      data.tabs.forEach(function (t, gi) {
        var gi2 = greenIndex(t);
        var gx = X0 + gi * span + (span - gw) / 2;
        var g = el('g', { 'class': 'rc__group', 'data-index': gi, tabindex: -1 });
        var title = el('title', {}); title.textContent = t.name; g.appendChild(title);
        g.appendChild(el('rect', { x: gx, y: Y1, width: gw, height: Y0 - Y1, 'class': 'rc__group-bg' }));
        t.rows.forEach(function (r, ri) {
          if (!hasValue(r)) return;
          var bx = gx + 16 + ri * 14;
          g.appendChild(el('path', { d: barPath(bx, y(toHours(r)), 6), 'class': 'rc__col' + (ri === gi2 ? ' is-highlight' : '') }));
        });
        svg.appendChild(g);
        groups.push(g);
      });
      $chart.empty().append(svg);

      $(svg).on('click', '.rc__group', function () { select(parseInt(this.getAttribute('data-index'), 10)); });

      // ---------- Stats ----------
      function renderStats(t) {
        var max = 0;
        t.rows.forEach(function (r) { if (hasValue(r)) max = Math.max(max, toHours(r)); });
        var green = greenIndex(t);
        var html = '';
        t.rows.forEach(function (r, ri) {
          if (!labels[ri]) return;
          var empty = !hasValue(r);
          var isGreen = !empty && ri === green;
          var tagHtml = (ri === baseline && tag) ? '<span class="rc__tag">' + $('<i>').text(tag).html() + '</span>' : '';
          var value, aria;
          if (empty) {
            value = '<em class="rc__na">' + $('<i>').text(naText).html() + '</em>';
            aria = naText;
          } else {
            var h = parseInt(r.h, 10) || 0, m = parseInt(r.m, 10) || 0;
            value = (h ? '<strong>' + h + '</strong><span>h</span>' : '') + '<strong>' + m + '</strong><span>m</span>';
            aria = h + ' hours ' + m + ' minutes';
          }
          html +=
            '<div class="rc__stat' + (isGreen ? ' is-highlight' : '') + (empty ? ' is-empty' : '') + '">' +
              '<div class="rc__bar-track"><div class="rc__bar" data-w="' + (!empty && max ? (toHours(r) / max) * 100 : 0) + '"></div></div>' +
              '<div class="rc__info">' +
                '<div class="rc__title">' + $('<i>').text(labels[ri]).html() + tagHtml + '</div>' +
                '<div class="rc__value" aria-label="' + $('<i>').text(aria).html() + '">' + value + '</div>' +
              '</div>' +
            '</div>';
        });
        $stats.html(html);
        // animate bars on next frame
        requestAnimationFrame(function () {
          $stats.find('.rc__bar').each(function () { this.style.width = this.getAttribute('data-w') + '%'; });
        });
      }

      function select(i) {
        active = i;
        $tabs.removeClass('is-active').attr('aria-selected', 'false')
          .eq(i).addClass('is-active').attr('aria-selected', 'true');
        groups.forEach(function (g, gi) {
          g.setAttribute('class', 'rc__group' + (gi === i ? ' is-active' : ''));
          // replay grow animation on the active group
          if (gi === i) $(g).find('.rc__col').each(function () {
            this.style.animation = 'none'; this.getBoundingClientRect(); this.style.animation = '';
          });
        });
        renderStats(data.tabs[i]);
      }

      $tabs.on('click', function () { select($tabs.index(this)); });
      $root.find('.rc__tablist').on('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        var next = (active + (e.key === 'ArrowRight' ? 1 : -1) + n) % n;
        select(next); $tabs.eq(next).trigger('focus');
      });

      select(0);

      // ---------- Video popup ----------
      var $modal = $root.find('.rc-modal');
      if ($modal.length) {
        $modal.appendTo(document.body);
        var $frame = $modal.find('.rc-modal__frame');
        var $opener = $root.find('[data-rc-video]');

        function ytId(url) {
          var mm = (url || '').match(/(?:youtu\.be\/|youtube(?:-nocookie)?\.com\/(?:watch\?(?:.*&)?v=|embed\/|shorts\/|live\/|v\/))([A-Za-z0-9_-]{11})/);
          return mm ? mm[1] : '';
        }
        function openVideo() {
          var id = ytId($opener.data('rcVideo'));
          if (!id) return;
          $frame.html('<iframe src="https://www.youtube-nocookie.com/embed/' + id +
            '?autoplay=1&rel=0&playsinline=1" title="Video" allow="autoplay; encrypted-media; picture-in-picture; fullscreen" allowfullscreen></iframe>');
          $modal.addClass('is-open');
          $('body').addClass('rc-lock');
          $modal.find('.rc-modal__close').trigger('focus');
        }
        function closeVideo() {
          $modal.removeClass('is-open');
          $('body').removeClass('rc-lock');
          $frame.empty();
          $opener.trigger('focus');
        }
        $opener.on('click', openVideo);
        $modal.on('click', '[data-rc-close]', closeVideo);
        $(document).on('keydown', function (e) { if (e.key === 'Escape' && $modal.hasClass('is-open')) closeVideo(); });
      }
    }

    $(function () { $('[data-rc]').each(function () { setup($(this)); }); });
    $(document).on('shopify:section:load', function (e) {
      $(e.target).find('[data-rc]').each(function () { setup($(this)); });
    });
    $(document).on('shopify:section:unload', function (e) {
      var id = $(e.target).find('[data-rc]').attr('data-rc');
      if (id) $('.rc-modal[data-rc-modal="' + id + '"]').remove();
    });
  }

  if (window.jQuery) {
    init(window.jQuery);
  } else {
    var s = document.createElement('script');
    s.src = 'https://cdnjs.cloudflare.com/ajax/libs/jquery/3.7.1/jquery.min.js';
    s.onload = function () { init(window.jQuery); };
    document.head.appendChild(s);
  }
})();